/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccounttDirectoryDeleteMutation($vendorAccounttDirectoryId: ID!) {
  VendorAccounttDirectoryDelete(vendorAccounttDirectoryId: $vendorAccounttDirectoryId) {
    id
    message
    status
  }
}
`
